import { StateMachine } from 'xstate'
import { Context, EventId, ReviewWizardEvent, StateId } from './machineTypes'
import { useInterpret } from '@xstate/react'

export const useInterpretReviewMachine = (
  machine: StateMachine<Context, any, ReviewWizardEvent>,
  args: { fetchConfig: boolean } = { fetchConfig: true },
) => {
  let options = {}
  if (machine.context.asset) {
    const state = machine.transition(machine.initialState, { type: EventId.CONTINUE })
    options = { state }
  }
  if (machine.context.reviewType) {
    const state = machine.transition(StateId.TYPE_SELECTION, { type: EventId.CONTINUE, fetchConfig: args.fetchConfig })
    options = { state }
  }

  return useInterpret(() => machine, options)
}
